export class Payment {
    bank: String;
    agency: String;
    account: String;
    digit: String;
    typePix: Number;
    keyPix: String;

    loadToEdit(r: any) {
        this.bank = r.bank;
        this.typePix = r.typePix;
        this.keyPix = r.keyPix;
        this.agency = r.agency;
        this.account = r.account;
        this.digit = r.digit;
    }
}


// WEBPACK FOOTER //
// ./src/app/models/Payment.model.ts